import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './table.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { ProcessImageModule } from '@core/components/process-image/process-image.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TippyModule } from '@ngneat/helipopper';
import { MatSelectModule } from '@angular/material/select';
import { AddQuickFilterDialogComponent } from './add-quick-filter-dialog.component';

@NgModule({
  declarations: [TableComponent, AddQuickFilterDialogComponent],
  exports: [TableComponent, AddQuickFilterDialogComponent],
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatChipsModule,
    MatCheckboxModule,
    MatRippleModule,
    MatMenuModule,
    ProcessImageModule,
    MatSlideToggleModule,
    FormsModule,
    MatDividerModule,
    MatBadgeModule,
    MatTooltipModule,
    TippyModule,
    MatSelectModule,
    ReactiveFormsModule
  ]
})
export class TableModule {}
